import axios from 'axios';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import { UserCreateModel } from '@/types';

const ExampleErrorsUrl = 'exampleErrors/';

export const ExampleErrorsService = {
  async getWithNotification(errorType: string): Promise<any> {
    const response = await axios.get(`${ExampleErrorsUrl}WithNotification/${errorType}`);
    return response.data;
  },
  async postBadRequest(userCreateModel: UserCreateModel): Promise<any> {
    const response = await axios.post(`${ExampleErrorsUrl}BadRequest`, userCreateModel);
    return response.data;
  },
  async getWithoutNotification(errorType: string): Promise<any> {
    const response = await AxiosConfiguration.axiosWithoutNotification.
      get(`${ExampleErrorsUrl}WithoutNotification/${errorType}`);
    return response.data;
  },
  async getWithErrorPage(errorType: string): Promise<any> {
    const response = await AxiosConfiguration.axiosWithErrorPage.get(`${ExampleErrorsUrl}WithErrorPage/${errorType}`);
    return response.data;
  }
};